import { schoolsSlice } from "./slice";

export const {
  setSelectedSession,
  setSelectedMedium,
  resetSchoolSlice,
  setSessionMonth,
  setSchoolsInitials,
} = schoolsSlice.actions;
